<form [formGroup]="PerfilForm" novalidate>
  <div class="row container mt-2">
    <div class="col-md-12">
      <div class="progress" id="progress" *ngIf="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
          aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
      </div>
      <div class="alert alert-success alert-dismissible fade show mt-2 lg-success" role="alert" *ngIf="alertSucces">
        <strong>Se ha generado la actualizacion!</strong> de forma exitosa.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert" *ngIf="alertError">
        <strong>ha fallado la actualización!</strong>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
  <div class="alert " role="alert" *ngIf="cargandoDatos" class="alert-success">
    <h4 class="alert-heading">Cargando datos</h4>
    <hr>
    <p class="mb-0">Se está cargando la información.</p>
    <app-progress *ngIf="cargandoDatos"></app-progress>
  </div>

  <div class="container border border-success rounded" *ngIf="!cargandoDatos">
    <div class="alert alert-info mt-2" role="alert">
      Revisa si tu información personal está completa y selecciona la opción “Guardar” para registrar tus avances. En el
      caso de que hayas finalizado, selecciona “Guardar y Continuar”.
    </div>
    <div class="container">
      <div class="card border border-success mt-3">
        <h5 class="card-header">
          Datos Personales
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DP" role="button" aria-expanded="true"
            aria-controls="DP"></a>
        </h5>
        <div class="collapse show" id="DP">
          <div class="card-body">
            <div class="row mt-2 container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Nacionalidad
                    </label>
                    <select formControlName="Nacionalidad" class="form-control form-control-sm">
                      <option value="">Seleccione</option>
                      <option value="1">Chilena</option>
                      <option value="2">Otra</option>
                    </select>
                  </div>
                  <div class="col-sm-6">

                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container" *ngIf="PerfilForm.controls.Nacionalidad.value == '1'">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label *ngIf="PerfilForm.controls.Nacionalidad.value == '1'">RUT</label>
                    <label *ngIf="PerfilForm.controls.Nacionalidad.value != '1'">Pasaporte</label>
                    <input type="text" formatRut class="form-control form-control-sm"
                      placeholder="Ingresa tu RUT con guión y sin puntos" formControlName="Rut" id="txtRut"
                      *ngIf="PerfilForm.controls.Nacionalidad.value === '1'">
                    <span class="text-muted" *ngIf="
                        PerfilForm.controls.TipoDocumentos.value === '1' &&
                        !PerfilForm.controls.Rut.valid &&
                        PerfilForm.controls.Rut?.touched
                      ">Por favor, ingrese un RUT válido</span>
                    <input type="text" class="form-control form-control-sm" placeholder="Ingresa tu Pasaporte"
                      formControlName="Passaporte" id="txtPasaporte"
                      *ngIf="PerfilForm.controls.Nacionalidad.value !== '1'">
                    <span class="text-muted" *ngIf="
                      PerfilForm.controls.TipoDocumentos.value !== '1' &&
                      !PerfilForm.controls.Passaporte.valid &&
                      PerfilForm.controls.Passaporte?.touched
                    ">Por favor, ingrese un Passaporte válido</span>
                  </div>
                  <div class="col-sm-6">
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Primer Nombre
                    </label>
                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                      placeholder="Ingresa primer nombre" formControlName="Nombre" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['Nombre'].valid &&
                        PerfilForm.controls['Nombre']?.touched
                      ">Por favor, ingrese un nombre válido</span>
                  </div>
                  <div class="col-sm-6">
                    <label>Segundo Nombre</label>
                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                      placeholder="Ingresa segundo nombre" formControlName="Nombre2" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['Nombre2'].valid &&
                        PerfilForm.controls['Nombre2']?.touched
                      ">Por favor, ingrese un segundo nombre válido</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Apellido Paterno
                    </label>
                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                      placeholder="Ingresa tu apellido paterno" formControlName="ApellidoP" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['ApellidoP'].valid &&
                        PerfilForm.controls['ApellidoP']?.touched
                      ">Por favor, ingrese un apellido válido</span>
                  </div>
                  <div class="col-sm-6">
                    <label>Apellido Materno</label>
                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                      placeholder="Ingresa tu apellido materno" formControlName="ApellidoM" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['ApellidoM'].valid &&
                        PerfilForm.controls['ApellidoM']?.touched
                      ">Por favor, ingrese un apellido válido</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Estado Civil</label>
                    <select formControlName="EstadoCivil" class="form-control form-control-sm">
                      <option value="">Seleccione</option>
                      <option value="1">Soltero/a</option>
                      <option value="2">Casado/a</option>
                      <option value="3">Divorciado/a</option>
                      <option value="4">Viudo/a</option>
                      <option value="5">Conviviente Civil</option>
                    </select>
                  </div>

                  <div class="col-sm-6">
                    <label>Género
                    </label>
                    <select formControlName="Genero" class="form-control form-control-sm">
                      <option value="">Seleccione</option>
                      <option value="1">Masculino</option>
                      <option value="2">Femenino</option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['Genero'].valid &&
                        PerfilForm.controls['Genero']?.touched
                      ">Por favor, selecionar un género válido</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Etnia
                    </label>
                    <select formControlName="Etnia" class="form-control form-control-sm">
                      <option value="">Seleccione</option>
                      <option value="1">Si</option>
                      <option value="2">No</option>
                    </select>
                  </div>

                  <div class="col-sm-6">

                  </div>

                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-sm-6">
                <label>Fecha de nacimiento
                  <span
                    *ngIf="PerfilForm.controls['FechaNacimiento'].hasError('required') || PerfilForm.controls['FechaNacimiento'].hasError('ValidarFecha')"
                    class="text-danger">*</span>
                </label>
                <input type="text" class="form-control form-control-sm" id="" placeholder="--"
                  formControlName="FechaNacimiento" (change)="changeFechaNacimieno()">
                <span class="text-muted"
                  *ngIf="!PerfilForm.controls['FechaNacimiento'].valid && PerfilForm.controls['FechaNacimiento']?.touched">Por
                  favor, ingrese una fecha válida. Debes ser mayor de 17 años y menor de 70 años</span>
              </div>
              <div class="col-sm-6">

              </div>
            </div>
            <div *ngIf="PerfilForm.controls['PresentaDiscapacidad']?.value == '1'" class="row mt-2 container">
              <div class="form-check">
                <br />
                <input class="form-check-input" type="checkbox" id="DeseaRecibirAsesoria"
                  formControlName="DeseaRecibirAsesoria" />

                <label class="form-check-label" for="DeseaRecibirAsesoria">
                  ¿Desea recibir orientación antes de matricularse?
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border border-success mt-1">
        <h5 class="card-header">
          Datos de contactabilidad
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DC" role="button" aria-expanded="true"
            aria-controls="DC"></a>
        </h5>
        <div class="collapse show" id="DC">
          <div class="card-body">
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Celular
                    </label>
                    <input type="text" class="form-control form-control-sm" placeholder="Ingresa tu teléfono Celular"
                      formControlName="Celular" appOnlyNumbersInput pattern="[0-9 ]*" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['Celular'].valid &&
                        PerfilForm.controls['Celular']?.touched
                      ">Por favor, ingrese un telefono válido</span>
                  </div>
                  <div class="col-sm-6">
                    <label>Correo electrónico
                    </label>
                    <input type="text" class="form-control form-control-sm" placeholder="Ingresa tu correo electrónico"
                      formControlName="CorreoElectronico" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['CorreoElectronico'].valid &&
                        PerfilForm.controls['CorreoElectronico']?.touched
                      ">Por favor, ingrese un correo electrónico válido</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Teléfono Fijo</label>
                    <input (keyup)="formatearTelefono(false)" type="text" class="form-control form-control-sm"
                      formControlName="Telefono" appOnlyNumbersInput prefijo="(2) "
                      placeholder="Ingresa tu teléfono (opcional)" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['Telefono'].valid &&
                        PerfilForm.controls['Telefono']?.touched
                      ">Por favor, ingrese un telefono válido</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border border-success mt-1" style="display: none;">
        <h5 class="card-header">
          Datos de Dirección
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DD" role="button" aria-expanded="true"
            aria-controls="DD"></a>
        </h5>
        <div class="collapse show" id="DD">
          <div class="card-body">
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>País <span class="text-danger">*</span></label>
                    <select formControlName="Pais" class="form-control form-control-sm">
                      <option value="">Seleccione</option>
                      <option *ngFor="let pais of Paises" value="{{ pais.Id }}">
                        {{ pais.Nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6">
                    <label>Región <span class="text-danger">*</span></label>

                    <select class="form-control form-control-sm" formControlName="Region"
                      (change)="ChangeRegion($event)">

                      <option value="" selected>Seleccionar</option>
                      <option *ngFor="let region of Regiones" value="{{region.Id}}">
                        {{region.Nombre}}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['Region'].valid &&
                        PerfilForm.controls['Region']?.touched
                      ">Por favor, selecionar una región válida</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Ciudad <span class="text-danger">*</span></label>
                    <select class="form-control form-control-sm" formControlName="Ciudad">
                      <option value="" selected>Seleccionar</option>
                      <option *ngFor="let ciudad of Ciudades" value="{{ ciudad.Id }}">
                        {{ ciudad.Nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6">
                    <label>Comuna <span class="text-danger">*</span></label>
                    <select class="form-control form-control-sm" formControlName="Comuna">
                      <option value="" selected>Seleccionar</option>
                      <option *ngFor="let comuna of Comunas" value="{{ comuna.Id }}">
                        {{ comuna.Nombre }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['Comuna'].valid &&
                        PerfilForm.controls['Comuna']?.touched
                      ">Por favor, selecionar una comuna válida</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Calle <span class="text-danger">*</span></label>
                    <input type="text" class="form-control form-control-sm" placeholder="Ingresa una direccion"
                      formControlName="Calle" />
                  </div>
                  <div class="col-md-3">
                    <label>Número</label>
                    <input class="form-control form-control-sm" id="CalleNro" formControlName="CalleNro" type="text" />
                  </div>
                  <div class="col-md-3">
                    <label>Departamento / Casa</label>
                    <input class="form-control form-control-sm" id="Dpto" formControlName="CalleDpto" type="text" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card border border-success mt-1" *ngIf="!mayorEdad">
        <h5 class="card-header">
          Datos del Sostenedor
          <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DDs" role="button" aria-expanded="true"
            aria-controls="DDs"></a>
        </h5>
        <div class="collapse show" id="DDs">
          <div class="card-body">
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>RUT <span class="text-danger">*</span></label>
                    <input type="text" (change)="checkRut($event)" formatRut class="form-control form-control-sm"
                      placeholder="Ingresar RUT" formControlName="ARut" id="txtRutA">
                    <span class="text-muted"
                      *ngIf="!PerfilForm.controls['ARut'].valid && PerfilForm.controls['ARut']?.touched">
                      Por favor, ingrese un rut válido
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <label>Número de serie <span class="text-danger">*</span></label>
                    <input (click)="formatearASerieRut()" (keyup)="formatearASerieRut()" type="text"
                      class="form-control form-control-sm" placeholder="Ingresa tu número de serie (sin puntos)"
                      formControlName="Aserialrut" />
                    <span class="text-muted"
                      *ngIf="!PerfilForm.controls['Aserialrut'].valid && PerfilForm.controls['Aserialrut']?.touched">
                      Ingresa tu número de serie. Ej: 123456789 (cédula nueva)/ A123456789 (cédula antigua)
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Nombre<span class="text-danger">*</span></label>
                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                      placeholder="Ingresar nombre ejemplo: Juan Perez" formControlName="ANombre" />
                    <span class="text-muted"
                      *ngIf="!PerfilForm.controls['ANombre'].valid && PerfilForm.controls['ANombre']?.touched || PerfilForm.controls['ANombre'].hasError('validarNombre')">
                      Por favor, ingrese un nombre válido
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <label>Apellido <span class="text-danger">*</span></label>
                    <input type="text" class="form-control form-control-sm" appOnlyLettersInput
                      placeholder="Ingresar apellido" formControlName="AApellido" />
                    <span class="text-muted"
                      *ngIf="!PerfilForm.controls['AApellido'].valid && PerfilForm.controls['AApellido']?.touched">
                      Por favor, ingrese un apellido válido
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Fecha de nacimiento <span class="text-danger">*</span>
                      <span class="text-danger" *ngIf="PerfilForm.controls['AFechaN'].hasError('required') ||
                          PerfilForm.controls['AFechaN'].hasError('ValidarFecha')">
                      </span>
                    </label>
                    <input type="date" class="form-control form-control-sm" id="" placeholder="--"
                      formControlName="AFechaN" />
                    <span class="text-muted"
                      *ngIf="!PerfilForm.controls['AFechaN'].valid && PerfilForm.controls['AFechaN']?.touched">
                      Por favor, ingrese una fecha válida. Debes ser mayor de 17 años y menor de 70 años.
                    </span>
                  </div>
                  <div class="col-sm-6"></div>
                </div>
              </div>
            </div>

            <div class="row mt-2 container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Región <span class="text-danger">*</span></label>
                    <select class="form-control form-control-sm" formControlName="ARegion"
                      (change)="ChangeRegion2($event)">
                      <option value="" selected>Seleccionar</option>
                      <option *ngFor="let region of RegionesApo" value="{{ region.Id }}">
                        {{ region.Nombre }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['ARegion'].valid &&
                        PerfilForm.controls['ARegion']?.touched
                      ">Por favor, selecionar una región válida</span>
                  </div>
                  <div class="col-sm-6">
                    <label>Comuna <span class="text-danger">*</span></label>
                    <select class="form-control form-control-sm" formControlName="AComuna">
                      <option value="" selected>Seleccionar</option>
                      <option *ngFor="let comuna of Comunas2" value="{{ comuna.Id }}">
                        {{ comuna.Nombre }}
                      </option>
                    </select>
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['AComuna'].valid &&
                        PerfilForm.controls['AComuna']?.touched
                      ">Por favor, selecionar una comuna válida</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2 container" style="display: none;">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Dirección <span class="text-danger">*</span></label>
                    <input type="text" class="form-control form-control-sm" placeholder="Ingresa una dirección"
                      formControlName="ADireccion" />
                  </div>
                  <div class="col-sm-6">
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Teléfono
                    </label>
                    <input type="text" class="form-control form-control-sm" placeholder="Ingresa tu teléfono"
                      formControlName="ATelefono" appOnlyNumbersInput />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['ATelefono'].valid &&
                        PerfilForm.controls['ATelefono']?.touched
                      ">Por favor, ingrese un teléfono válido</span>
                  </div>
                  <div class="col-sm-6">
                    <label>Correo electrónico
                    </label>
                    <input type="text" class="form-control form-control-sm" placeholder="Ingresa tu correo electrónico"
                      formControlName="ACorreo" />
                    <span class="text-muted" *ngIf="
                        !PerfilForm.controls['ACorreo'].valid &&
                        PerfilForm.controls['ACorreo']?.touched
                      ">Por favor, ingrese un correo electrónico válido</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="alert alert-danger fade show alert-dismissible mt-2" role="alert"
    *ngIf="PerfilForm.invalid && !cargandoDatos">
    <strong><i class="fa fa-info-circle" aria-hidden="true"></i></strong> Faltan campos * requeridos en el formulario
    <br>

    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="alert alert-info mt-2" role="alert">
    <!--Si tus datos se encuentran erróneos, favor contactar a los asesores de Matrícula <br> de la Universidad Santo Tomás,
    al +56228402242.-->
    Si tus datos est&aacute;n incorrectos, contacta v&iacute;a WhatsApp a los Asesores de Matr&iacute;cula en 
    el tel&eacute;fono +562 2840 2242 
  </div>

  <div class="row mb-2 mt-2" *ngIf="!cargandoDatos && (FaseActual === '1' || !FaseActual ) || TieneBloqueoAcademico">
    <div class="col-md-3">&nbsp;</div>
    <div class="col-md-6 ml-2">
      <app-apibutton text="Guardar y continuar" [progress]="progress" (click)="guardar_y_Actualizar()"
        *ngIf="habilitaBotones"></app-apibutton>
      <app-apibutton text="Confirmar y continuar" [progress]="progress" (click)="confirmar_y_Actualizar()"
        *ngIf="habilitaBotonesAdecuaciones"></app-apibutton>
    </div>
    <div class="col-md-3">&nbsp;</div>
  </div>

</form>
